
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'AgeLimit12'
})
export default class AgeLimit12 extends Vue {}
